// Ask the global UpgradeDialog to show, with an optional feature name + perks.
export const promptUpgrade = (feature, perks = []) =>
  window.dispatchEvent(new CustomEvent("cb-show-upgrade", { detail: { feature, perks } }));

// Signal a "happy moment" (chapter finished, quiz done) — ReviewPrompt may,
// occasionally and tactfully, ask for a Google Play rating.
export const happyMoment = () =>
  window.dispatchEvent(new Event("cb-happy-moment"));
